var _rect, _text, _text2, _rect2, _text3, _text4, _text5, _text6, _path, _polygon, _rect3, _text7, _text8, _text9, _text10, _path2, _polygon2, _rect4, _text11, _text12, _text13, _text14, _path3, _polygon3, _rect5, _text15, _text16, _text17, _text18, _text19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01EvolutionLayers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 320",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 320,
    fill: "#fafafa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 36,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "The Evolution Stack")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 58,
    textAnchor: "middle",
    fill: "#666",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Each layer solves a failure the previous one could not")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 90,
    width: 190,
    height: 140,
    rx: 12,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 2.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 145,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Prompt")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 168,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Engineering")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 200,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "What do I tell")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 216,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "the model?")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230 160 L258 160",
    stroke: "#111",
    strokeWidth: 2.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "262,160 252,154 252,166",
    fill: "#111"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 90,
    width: 190,
    height: 140,
    rx: 12,
    fill: "#bbf7d0",
    stroke: "#111",
    strokeWidth: 2.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 145,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Context")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 168,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Engineering")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 200,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "What should it")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 216,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "see right now?")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470 160 L498 160",
    stroke: "#111",
    strokeWidth: 2.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "502,160 492,154 492,166",
    fill: "#111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 90,
    width: 190,
    height: 140,
    rx: 12,
    fill: "#bfdbfe",
    stroke: "#111",
    strokeWidth: 2.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 145,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Harness")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 168,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Engineering")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 200,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "What environment")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 216,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "does it run in?")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M710 160 L738 160",
    stroke: "#111",
    strokeWidth: 2.5
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "742,160 732,154 732,166",
    fill: "#111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 90,
    width: 120,
    height: 140,
    rx: 12,
    fill: "#e5e7eb",
    stroke: "#111",
    strokeWidth: 2.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 145,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Loop")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 168,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Engineering")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 200,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "When to act,")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 216,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "retry, stop?")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 280,
    textAnchor: "middle",
    fill: "#555",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Layers nest. They do not replace each other.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01EvolutionLayers);
export default __webpack_public_path__ + "static/media/01-evolution-layers.f6b8c8a9177200b4077c18b8202bee29.svg";
export { ForwardRef as ReactComponent };